var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgilysysIgkds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1373.5 407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #0299d6;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #7fbc42;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #231f20;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M518.8,353.9h-29.9v-216.8h29.9v216.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M731.7,145.9l-4.9,23.8c-18.6-7.5-39.4-12-59.6-12-53.7,0-86.6,32.9-86.6,90.5s29.6,86.3,87.2,86.3,29-2.3,39.1-5.2v-70.6h27.3v87.2c-16.3,6.8-44.6,12-70,12-71.3,0-113.6-44.9-113.6-109.7s43.6-114.9,116.2-114.9,47.2,4.2,64.8,12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M838.4,353.9v-216.8h29.9v105.1l90.5-105.1h36.1l-93.4,107.4,99.6,109.4h-37.8l-95-107.4v107.4h-29.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1025.6,137.1h60.2c74.5,0,123.7,46.2,123.7,108.4s-49.2,108.4-123.7,108.4h-60.2v-216.8ZM1179.5,245.5c0-53.4-41.3-84.3-93.7-84.3h-30.3v168.6h30.3c52.4,0,93.7-30.9,93.7-84.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1287,357.8c-20.8,0-43.9-4.2-62.2-13l5.9-23.8c15.9,7.5,36.1,12.7,55.7,12.7,28,0,47.2-12.4,47.2-34.8s-21.8-34.5-47.5-46.5c-29.3-13.7-56.6-29.6-56.6-62.2s28-57,69-57,41.7,5.2,56.3,13l-5.5,23.8c-14-7.2-32.9-12.7-50.8-12.7-25.7,0-39.4,10.7-39.4,30.6s9.8,25.4,37.8,39.1c28,13.7,66.4,31.2,66.4,70.6s-33.9,60.2-76.2,60.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.7,178.1c46.4,0,84.1-37.6,84.1-84.1S424.2,10,377.7,10s-84.1,37.6-84.1,84.1,37.6,84.1,84.1,84.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.9,123c10.5,13.7,16.3,32.4,16.3,55.7v118h-35.9v-24.5c-11.4,14.3-35.9,28.6-65.3,28.6s-55.9-21.2-55.9-54.3,27.4-53.9,69.8-56.7c17.6-1.2,34.7-1.6,50.6-1.6v-8.6c0-33.1-13.5-53.1-45.7-53.1s-36.3,5.3-51.8,13.9l-8.6-26.9c20.4-12.2,41.6-16.7,66.9-16.7s12.7.6,18.5,1.8c-17.9-7.2-37.4-11.2-57.9-11.2-85.4,0-154.7,69.3-154.7,154.7s69.3,154.7,154.7,154.7,154.7-69.3,154.7-154.7-21.7-90.5-55.7-118.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.6,246.4c0,18.4,11.4,27.3,31,27.3s40.4-10.6,53.9-25.3v-36.3c-16.3.8-30.2,2-44.1,3.7-22.9,2.4-40.8,9.4-40.8,30.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgilysysIgkds);
export default __webpack_public_path__ + "static/media/AgilysysIGKDS.20d42a8b3f44bb09e956e45aceebd323.svg";
export { ForwardRef as ReactComponent };